import { COMMON_EVENT_PROPERTIES } from 'eventsTracking/constants';
import { trackEvent } from '@raisin/events-tracking';
import { CustomerPortalEvent } from 'eventsTracking/types';
import { getCommonDynamicData } from 'eventsTracking/utils';

export interface BankDetailsParams {
  distributorId: string;
  eventName: string;
  action?: string;
  object?: string;
  bank_id: string | undefined;
  productId: string | undefined;
  product_type: string | undefined;
  interestRates: {
    interest_rate_nominal: string | undefined;
    interest_rate_effective: string | undefined;
  };
  bankPage: string;
}

/**
 * Contains all Bank Details events.
 */
export const BANK_DETAILS_EVENT = {
  ON_CLICK_ITEMS_HANDLER: (params: BankDetailsParams) =>
    ({
      ...COMMON_EVENT_PROPERTIES,
      ...getCommonDynamicData(params),
      action: 'clicked',
    } as CustomerPortalEvent),
  ON_TOP_OFFER_CLICKED: (params: BankDetailsParams) =>
    ({
      ...COMMON_EVENT_PROPERTIES,
      ...getCommonDynamicData(params),
      action: 'clicked',
      object: 'top_offer',
    } as CustomerPortalEvent),
  ON_PRODUCT_EXPANDED: (params: BankDetailsParams) =>
    ({
      ...COMMON_EVENT_PROPERTIES,
      ...getCommonDynamicData(params),
      action: 'expanded',
      object: 'product',
    } as CustomerPortalEvent),
};

/**
 *
 * @param BANK_DETAILS_EVENTS
 * @returns method to trigger all the events on Bank Details
 */
export const trackBankDetailsPageClick = (params: BankDetailsParams) => {
  trackEvent(BANK_DETAILS_EVENT.ON_CLICK_ITEMS_HANDLER(params), true);
};

export const trackTopOfferClick = (params: BankDetailsParams) => {
  trackEvent(BANK_DETAILS_EVENT.ON_TOP_OFFER_CLICKED(params), true);
};

export const trackProductExpanded = (params: BankDetailsParams) => {
  trackEvent(BANK_DETAILS_EVENT.ON_PRODUCT_EXPANDED(params), true);
};
